module.exports = __webpack_public_path__ + "media/images/icon/gray/ico_angle_right-8a4192e8f33571bf5344d1683eee3587.svg";